export const basicInfo = {
  id: "门店ID",
  spName: "名称",
  loginAccount: "账号",
  contactPerson: "联系人",
  retName: "关联经销商"
};

export const displayInfo = {
  detailViewList: "陈列数量",
  submitTime: "上传时间",
  imageList: "陈列图"
};

export const basicPosInfo = {
  id: "门店ID",
  spName: "名称",
  loginAccount: "账号",
  contactPerson: "联系人",
  retName: "关联经销商"
};




// WEBPACK FOOTER //
// ./src/views/shopTask/validate/constants.js